export default __webpack_public_path__ + "static/media/up2date.7512fa6b.png";